import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/ar-watch"
    path="business/products/ar-watch"
    element={<AsyncPage />}
  />,
];
